import styled from 'styled-components';
import primitives from '@veneer/primitives';
import { IconEnvelope as VeneerIconEnvelope, IconPhone as VeneerIconPhone } from '@veneer/core';

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 0 ${primitives.layout.size3}px;
  gap: ${primitives.layout.size3}px;
  border-bottom: 1px solid ${primitives.color.gray3};
  min-height: 80px;

  &:last-child {
    border-bottom: none;
  }
`;

export const AvatarContainer = styled.div`
  min-width: 48px;
  min-height: 48px;
`;

export const InfoContainer = styled.div`
  height: fit-content;
  flex: 1;
  min-width: 0;
  padding: ${primitives.layout.size4}px 0 ;
`;

export const UserName = styled.h3`
  margin-bottom: ${primitives.layout.size1}px;
`;

export const Email = styled.p`
  word-break: break-word;
  display: block;
`;

export const PhoneNumber = styled.p`
  word-wrap: anywhere;
`;

export const AddonsWidgetContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${primitives.layout.size2}px;
`;

export const IconEnvelope = styled(VeneerIconEnvelope)`
  && {
    color: ${primitives.color.gray7};
    min-width: 17px;
    min-height: 17px;
  }
`;

export const IconPhone = styled(VeneerIconPhone)`
  && {
    color: ${primitives.color.gray7};
    min-width: 16px;
    min-height: 16px;
  }
`;
